<template>
  <div>
    <b-modal 
      id="th-accommodation-modal" 
      ref="th-accommodation-modal-ref" 
      hide-footer title="Accommodation Information"
    >
      <div class="mb-5 mt-5">
        <h2 class="text-center mb-3">{{ accommodationItem.title }}</h2>
        <!-- <h4 class="text-center mb-3">{{ accommodationItem.classification }}</h4> -->
        <div class="w-100 text-center my-3">
          <StarRating 
            :classification="accommodationItem.classification"
          />
        </div>
        <Slider
          v-if="images && images.length"
          :images="images" 
          :controls="true" 
          image-size="large"
        />
      </div>
      <div v-if="description" class="mb-5 mt-5">
        <h4 class="text-center mb-3">Trailfinders View:</h4>
        <p v-html="description"></p>
        <template v-if="accommodationItem.accommodation.address !== ''">
          <h4 class="text-center mb-3">
            Address:
          </h4>
          <p class="text-center">
            {{ accommodationItem.accommodation.address }}
          </p>
        </template>
      </div>
    </b-modal>
  </div>
</template>
  
  <script>
  import Slider from '../slider/index.vue'
  import StarRating from '../starRating'
  export default {
    name: 'TouringAccommodation',
    components: {
      Slider,
      StarRating
    },
    props: {
      accommodationItem: {
        type: Object
      }
    },
    data() {
      return {
        images: [],
        description: '',
        activeItemIndex: 0
      }
    },
    computed: {
      activeItem () {
        return this.activeItemIndex
      }
    },
    mounted () {
      this.getAccommodationData(0)
    },
    methods: {
      showModal() {
        this.$refs["th-accommodation-modal-ref"].show();
      },
      getAccommodationData (placeIndex) {
        // Set active item
        this.activeItemIndex = placeIndex
        // Get any other images
        const images = this.accommodationItem.media.images
        // Get description
        const description = this.accommodationItem.description
        // combine in image array
        this.images = [...images]
        // Set description
        this.description = description
      },
      handleSelect (placeIndex) {
        this.getPlaceData(placeIndex)
      }
    },
  };
  </script>
  
  <style lang="scss">
  .places {
    display: flex;
    justify-content: space-between;
    align-items: center;
    overflow: auto;
    white-space: nowrap;
  }
  .place-select {
    cursor: pointer;
  }
  .active-place {
    font-weight: bold;
  }
  </style>